var audio_default = {
  "fontElementMap": "dgAMn",
  "container": "_4eixQ",
  "coverImageContainer": "Dl-BO",
  "customPlayer": "wUaW7",
  "slim": "Zsbz2",
  "playPauseButton": "_7tfFc",
  "coverImage": "CoEWK",
  "trackDetailsContainer": "hrdNI",
  "controlsContainer": "S0exc",
  "controlsGroup": "aSB-3",
  "sliderContainer": "g49AQ",
  "audioDuration": "svRKy",
  "isLoading": "wSoSf",
  "audioDetails": "_4yPdp",
  "authorName": "n5-b6",
  "title": "eWxWs",
  "dropdownMenuWrapper": "PeG7L",
  "dropdownSelectedButton": "_2OfLa",
  "dropdownContent": "lonLt",
  "dropdownContentWithIcon": "_2OeIS",
  "audioLoader": "t-vhf"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
